// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"0cc48d0c","797":"d72390d3"}[chunkId] + ".chunk.js";
};